import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import {
    SuiteRfbFeaturesModule,
    SuiteRfbHeaderModule,
    SuiteRfbNavbarModule,
    SuiteRfbAlertMessagesModule,
    SuiteRfbFooterModule,
    SuiteRfbLoadingModule,
    Features,
    SuiteRfbExpandedMenuModule,
    SuiteRfbCollapseModule,
    SuiteRfbDatePickerModule,
    SuiteRfbPaginationModule,
    SuiteRfbSelectModule,
    SuiteRfbTableModule,
    SuiteRfbFilterByModule,
    SuiteRfbConfirmationsModule,
    SuiteRfbSortByModule,
    SuiteRfbInputMaskModule,
    SuiteRfbInputValidationModule,
    SuiteRfbRadioModule,
    SuiteRfbPopoverModule,
    SuiteRfbToggleModule,
    SuiteRfbTabsModule
} from '@serpro/ngx-suite-rfb';
import { AppRoles } from './auth/app-roles';

const FEATURES: Features = [
    {
        title: 'Início',
        route: '/dashboard',
        menu: false,
        linked: false
    },
    {
        title: 'Atos',
        menu: true,
        rolesAllowed: [AppRoles.ROLE_GESTOR, AppRoles.ROLE_USUARIO],
        children: [
            {
                title: 'Incluir ato',
                route: '/atos/incluir-ato',
                menu: true,
                linked: false
            },
            {
                title: 'Gerir atos',
                route: '/atos/gerir-atos',
                menu: true,
                linked: false
            },
            {
                title: 'Fazer e desfazer anotações',
                route: '/anotacoes/fazer-desfazer-anotacoes',
                menu: true,
                linked: false
            },
        ]
    },
    {
        title: 'Ferramentas',
        menu: true,
        rolesAllowed: [AppRoles.ROLE_GESTOR, AppRoles.ROLE_USUARIO],
        children: [
            {
                title: 'Consultar importações',
                route: '/ferramentas/consultar-importacoes',
                menu: true,
                linked: false
            },
            {
                title: 'Detalhar importação',
                route: '/ferramentas/detalhar-importacao',
                menu: false,
                linked: false
            },
            {
                title: 'Visualizar detalhe de importação',
                route: '/ferramentas/visualizar-detalhe',
                menu: false,
                linked: false
            },
            {
                title: 'Importar sob demanda',
                route: '/ferramentas/importar-sob-demanda',
                menu: true,
                linked: false
            },
            {
                title: 'Gerir tipos de segmento',
                route: '/tipos-segmento/gerir-tipos-segmento',
                menu: true,
                linked: false
            },
            {
                title: 'Gerir banco de LUDs',
                route: '/luds/gerir-luds',
                menu: true,
                linked: false
            },
        ]
    },
    {
        title: 'Parâmetros',
        menu: true,
        rolesAllowed: [AppRoles.ROLE_GESTOR],
        children: [
            {
                title: 'Configurar inclusão automática',
                route: '/parametros/configurar-inclusao-automatica',
                menu: true,
                linked: false
            },
            {
                title: 'Gerir filtros da importação',
                route: '/parametros/gerir-filtros',
                menu: true,
                linked: false
            },
            {
                title: 'Novo filtro',
                route: '/parametros/gerir-filtros/novo',
                menu: false,
                linked: false
            },
            {
                title: 'Editar filtro',
                route: '/parametros/gerir-filtros/editar',
                menu: false,
                linked: false
            },
            {
                title: 'Gerir tipos de anotação',
                route: '/anotacoes/gerir-tipos-anotacao',
                menu: true,
                linked: false
            },
        ]
    }
];

@NgModule({
    imports: [
        SuiteRfbFeaturesModule.forRoot(FEATURES, {
            applicationsMenuHidden: true,
            contextualHelpHidden: true,
            notificationsHidden: true,
            logoutHidden: true,
            userConfigurationsHidden: true
        }),
        SuiteRfbHeaderModule,
        SuiteRfbNavbarModule,
        SuiteRfbFooterModule,
        SuiteRfbAlertMessagesModule,
        SuiteRfbLoadingModule,
        SuiteRfbExpandedMenuModule,
        SuiteRfbDatePickerModule,
        SuiteRfbSelectModule,
        SuiteRfbCollapseModule,
        SuiteRfbPaginationModule,
        SuiteRfbTableModule,
        SuiteRfbSortByModule,
        SuiteRfbConfirmationsModule,
        SuiteRfbFilterByModule,
        SuiteRfbInputMaskModule,
        SuiteRfbInputValidationModule,
        SuiteRfbRadioModule,
        SuiteRfbPopoverModule,
        SuiteRfbToggleModule,
        SuiteRfbTabsModule,
        TooltipModule
    ],
    exports: [
        SuiteRfbFeaturesModule,
        SuiteRfbAlertMessagesModule,
        SuiteRfbHeaderModule,
        SuiteRfbNavbarModule,
        SuiteRfbFooterModule,
        SuiteRfbLoadingModule,
        SuiteRfbExpandedMenuModule,
        SuiteRfbDatePickerModule,
        SuiteRfbSelectModule,
        SuiteRfbCollapseModule,
        SuiteRfbPaginationModule,
        SuiteRfbTableModule,
        SuiteRfbSortByModule,
        SuiteRfbConfirmationsModule,
        SuiteRfbFilterByModule,
        SuiteRfbInputMaskModule,
        SuiteRfbInputValidationModule,
        SuiteRfbRadioModule,
        SuiteRfbPopoverModule,
        SuiteRfbToggleModule,
        SuiteRfbTabsModule,
        TooltipModule
    ]
})
export class AppSuiteRfbModule { }